if (!customElements.get("klaviyo-waitlist")) {
  class KlaviyoWaitlist extends HTMLElement {
    constructor() {
      super();
      this.klaviyoEnabled = false;
      this.variantMetafields = null;
      
      this.klaviyoConfig = {
        trigger: {
          product_page_text: "Notify Me When Available",
          product_page_class: "button",
          product_page_text_align: "center",
          product_page_margin: "0px",
          alternate_anchor: "AddToCart",
          replace_anchor: false
        },
        modal: {
          headline: "{product_name}",
          body_content: "Register to receive a notification when this item comes back in stock.",
          email_field_label: "Email",
          button_label: "Notify me when available",
          subscription_success_label: "You're in! We'll let you know when it's back.",
          footer_content: '',
          additional_styles: "",
          drop_background_color: "#000",
          background_color: "#fff",
          text_color: "#000",
          button_text_color: "#fff",
          button_background_color: "#ff5741",
          close_button_color: "#ccc",
          error_background_color: "#fcd6d7",
          error_text_color: "#C72E2F",
          success_background_color: "#d3efcd",
          success_text_color: "#1B9500"
        }
      };
    }

    connectedCallback() {
      this.variantMetafields = JSON.parse(this.getAttribute('variant-metafields') || '{}');
      this.setupVariantListener();
      this.initializeForCurrentVariant();
    }

    setupVariantListener() {
      document.addEventListener('variant:changed', (event) => {
        const variant = event.detail.variant;
        if (variant) {
          this.handleVariantChange(variant);
        }
      });
    }

    initializeForCurrentVariant() {
      const masterSelector = document.querySelector('[name="id"]');
      if (masterSelector?.value) {
        this.handleVariantChange({ id: parseInt(masterSelector.value) });
      }
    }

    handleVariantChange(variant) {
      if (!this.variantMetafields?.[variant.id]) return;

      const showWaitlistButton = this.variantMetafields[variant.id].show_waitlist_button;
      
      if (showWaitlistButton) {
        this.showWaitlistButton();
      } else {
        this.hideWaitlistButton();
      }
    }

    showWaitlistButton() {
      this.removeHideStyle();
      this.showExistingButtons();
      this.enableKlaviyo();
    }

    hideWaitlistButton() {
      this.hideExistingButtons();
      this.addHideStyle();
    }

    enableKlaviyo() {
      if (typeof klaviyo !== 'undefined' && !this.klaviyoEnabled) {
        const config = { ...this.klaviyoConfig };
        
        // Always hide the select dropdown since we only want to track the current variant
        config.modal.additional_styles = "#variants { display: none !important; }";
        
        klaviyo.enable("backinstock", config);
        this.klaviyoEnabled = true;
      }
    }

    showExistingButtons() {
      document.querySelectorAll('.klaviyo-bis-trigger').forEach(button => {
        button.style.display = '';
      });
    }

    hideExistingButtons() {
      document.querySelectorAll('.klaviyo-bis-trigger').forEach(button => {
        button.style.display = 'none';
      });
    }

    addHideStyle() {
      this.removeHideStyle();
      const style = document.createElement('style');
      style.id = 'klaviyo-hide-style';
      style.textContent = '.klaviyo-bis-trigger { display: none !important; }';
      document.head.appendChild(style);
    }

    removeHideStyle() {
      const existingStyle = document.getElementById('klaviyo-hide-style');
      if (existingStyle) existingStyle.remove();
    }
  }

  customElements.define("klaviyo-waitlist", KlaviyoWaitlist);
}
